import { render, staticRenderFns } from "./User.list.component.vue?vue&type=template&id=e0c6087c&"
import script from "./User.list.component.vue?vue&type=script&lang=js&"
export * from "./User.list.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports